import React, { useEffect, useState } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  CircularProgress
} from '@mui/material';
import axiosInstance from '../../utils/axios';
import { Branch } from '../../types';

interface BranchSelectorProps {
  value: string;
  onChange: (branchId: string) => void;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
  showAll?: boolean;
}

const BranchSelector: React.FC<BranchSelectorProps> = ({
  value,
  onChange,
  label = 'Sucursal',
  required = false,
  disabled = false,
  fullWidth = true,
  size = 'medium',
  showAll = false
}) => {
  const [branches, setBranches] = useState<Branch[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const response = await axiosInstance.get('/branches');
        setBranches(response.data);
      } catch (error) {
        console.error('Error al cargar sucursales:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchBranches();
  }, []);

  const handleChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value);
  };

  if (loading) {
    return <CircularProgress size={24} />;
  }

  return (
    <FormControl fullWidth={fullWidth} margin="normal" size={size} required={required}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        onChange={handleChange}
        label={label}
        disabled={disabled}
      >
        {showAll && (
          <MenuItem value="">
            <em>Todas las sucursales</em>
          </MenuItem>
        )}
        {branches.map((branch) => (
          <MenuItem key={branch.id} value={branch.id}>
            {branch.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default BranchSelector;
